export const INTERCOM_EVENTS = {
  SIGNUP: {
    SUCCEED: 'signup succeed',
    FLOW_FINISHED: 'signup flow finished',
  },
  QUICK_SIGNUP: {
    QUICK_SIGNUP: 'quick-signup',
  },
  GENERAL: {
    LAUNCHER_CLICKED_1: 'launcher-clicked-1',
    LAUNCHER_CLICKED_2: 'launcher-clicked-2',
    SIGNUP_15_SECONDS: 'signup-15-seconds',
    SIGNUP_30_SECONDS: 'signup-30-seconds',
  },
  MISSING_CRITICAL_INFORMATION: {
    NEED_HELP: 'missing-critical-information-need-help',
    POPUP_SUCCESS: 'missing-critical-information-succeed',
    POPUP_FAIL: 'missing-critical-information-failed',
    POPUP_COMPLETED: 'missing-critical-information-completed',
  },
  SHARE: {
    TRIALS: 'trials-share',
    TREATMENTS: 'soc-share',
    BLOGPOST: 'blogpost-share',
  },
  SHARE_WITH_DOCTOR: {
    POPUP_SUCCESS: 'share-with-doctor-succeed',
    POPUP_FAIL: 'share-with-doctor-failed',
  },
  CONSULT_WITH_US: {
    POPUP_SUCCESS: 'consult-with-us-succeed',
    POPUP_FAIL: 'consult-with-us-failed',
  },
  NEXT_APPOINTMENT: {
    POPUP_SUCCESS: 'next-appointment-succeed',
    POPUP_FAIL: 'next-appointment-fail',
  },
  NGS: {
    WRONG_FORMAT: 'ngs-need-help-wrong-format',
    BIOMARKERS_NOT_EXTRACTED: 'ngs-wrong-file-biomarkers-not-extracted',
  },
  MEDICAL_FILES: {
    UPLOADED: 'medical-files-uploaded',
    SUCCEED: 'medical-files-succeed',
    ERROR: 'medical-files-error',
  },
  UPLOAD_PAGE: {
    USER_SIGNUP: 'user-complete-signup-at-upload-page',
  },
  TRIAL_CONTACT: {
    TRIAL_REQUEST_INFO_CLICKED: 'trial_request_info_clicked',
    TRIAL_CONTACT_SITE_SUBMIT_FORM: 'trial_contact_site_submit_form',
    TRIAL_SEE_CONTACT_DETAIL: 'trial_see_contact_detail',
  },
};
